import { DrawingStyle, DrawingType } from '@editor/interfaces/drawing'

import { BlueprintEditorTools } from './definitions'

export const BLUEPRINT_TOOL_LABELS: Record<BlueprintEditorTools, string> = {
  // leave empty, just to satisfy the type
  [BlueprintEditorTools.BlueprintManager]: '',
  [BlueprintEditorTools.MaskPCD]: '',
  [BlueprintEditorTools.Editor3DElements]: '',

  [BlueprintEditorTools.Selector]: '選択',
  [BlueprintEditorTools.Pen]: 'ペンツール',
  [BlueprintEditorTools.Polygon]: 'ポリゴンツール',
  [BlueprintEditorTools.Circle]: '円ツール',
  [BlueprintEditorTools.Rectangle]: '矩形ツール',
  [BlueprintEditorTools.TextAnnotation]: '注釈',
  [BlueprintEditorTools.MeasurementLabel]: '寸法',

  [BlueprintEditorTools.Focus]: 'カメラ中心の設定',
}

export const COMMON_STYLES: DrawingStyle[] = [
  DrawingStyle.StrokeColor,
  DrawingStyle.StrokeWidth,
  DrawingStyle.StrokeStyle,
]

export const AVAILABLE_STYLES: Record<DrawingType, DrawingStyle[]> = {
  [DrawingType.Polyline]: [...COMMON_STYLES],
  [DrawingType.Polygon]: [...COMMON_STYLES, DrawingStyle.FillColor],
  [DrawingType.Circle]: [...COMMON_STYLES, DrawingStyle.FillColor],
  [DrawingType.TextAnnotation]: [DrawingStyle.TextColor, DrawingStyle.TextSize, ...COMMON_STYLES],
  [DrawingType.MeasurementLabel]: [
    DrawingStyle.TextColor,
    DrawingStyle.TextSize,
    DrawingStyle.TextOffset,
    ...COMMON_STYLES,
  ],
}

export const DEFAULT_DOCUMENT = Object.freeze({
  drawings: [],
  editorElements: {
    inspectionItems: [],
    polygons: [],
    cylinders: [],
  },
})

export const MAX_TEXT_OFFSET = 50
export const MIN_TEXT_OFFSET = -50

// Ratio used to determine the gap size for dashed lines based on the line width.
// A value of 800 was chosen empirically to produce visually balanced dashed lines
// across a range of line widths in the blueprint editor.
export const LINE_WIDTH_TO_GAP_RATIO = 800
